import { decodeJwt } from 'jose';
import { getEnvVar } from '@/utils/env';
import authFactory from '@/config/authFactory';
import { createUserInfo } from '@/modules/user/userInfoFactory';
import { useUserInfoStore } from '@/modules/user/userInfoStore';

// Returns the userInfo from the token itself if non DEV env. otherwise from the store
export const useUserInfo = () => {
  const auth = authFactory().getInstance();
  const isDev = getEnvVar('VITE_SITE') === 'DEV';

  const getUserInfo = async () => {
    if (isDev) {
      return useUserInfoStore().currentUser;
    } else {
      return createUserInfo(auth.getUserInfo(await getToken()));
    }
  };

  // userInfo is stored only for DEV env. other userInfo is extracted on the fly
  // from the token. Call has no effect for non DEV env.
  const setUserInfo = (token: string) => {
    if (isDev) {
      const userInfo = userInfoFactory(token);
      useUserInfoStore().setUserInfo(userInfo);
    }
  };

  // Returns a stored token only for Dev env. otherwise returns undefined.
  const getToken = async () => {
    if (isDev) {
      return useUserInfoStore().token;
    } else {
      return window.sso ? await window.sso.getUserToken() : await auth.getUserToken(false);
    }
  };

  // Returns a stored token only for Dev env. otherwise returns undefined.
  const setToken = (token: string) => {
    if (isDev) {
      useUserInfoStore().setToken(token);
    }
  };

  const resetUserInfo = () => {
    useUserInfoStore().reset();
  };

  const userInfoFactory = (token: string) => {
    return createUserInfo(decodeJwt(token));
  };

  return {
    userInfoFactory,
    getUserInfo,
    setToken,
    getToken,
    setUserInfo,
    resetUserInfo
  };
};

export default useUserInfo;
